import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-documents-user-consult',
  templateUrl: './documents-user-consult.component.html',
  styleUrls: ['./documents-user-consult.component.css']
})
export class DocumentsUserConsultComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
